module.exports = __webpack_public_path__ + "img/mystic_clouds.6176f31a.png";